<page-toolbar [pageActions]="pageActions" [title]="title"></page-toolbar>


<page-content *ngIf="!isLoading">
  <ng-container *ngIf="!!screenSettings && screenSettings.detail">

    <json-content-table [json]="screenSettings.detail" [title]="'Screen Settings'" displayStyle="detail">
    </json-content-table>

  </ng-container>

  <mat-card appearance="outlined" *ngIf="!screenSettings || !screenSettings.detail">There are no legacy screen settings</mat-card>

</page-content>
